import React from 'react';
import { ThemeContext } from 'styled-components';

import roverTheme from '@rover/kibble/themes/roverTheme';

function useTheme(): typeof roverTheme {
  const theme = React.useContext(ThemeContext) as typeof roverTheme;
  return theme || roverTheme;
}

export default useTheme;
